import { Item } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/QuerySuggestions/components/item";
import { Items } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/QuerySuggestions/components/items";
import { Base } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/QuerySuggestions/querySuggestions.base";

export const QuerySuggestions = Object.assign(Base, {
    Items: Items,
    Item: Item
});
